// src/pages/HomeView/components/TabNavigator.tsx
import React from 'react';
import type { HomeTab } from '../HomeViewPage';

interface TabNavigatorProps {
  activeTab: HomeTab;
  onTabChange: (tab: HomeTab) => void;
}

export const TabNavigator: React.FC<TabNavigatorProps> = ({ activeTab, onTabChange }) =>
{
  const tabs: { id: HomeTab; label: string }[] = [
    { id: 'newsfeed', label: 'NewsFeed' },
    { id: 'assets', label: 'Assets' },
    { id: 'efficiency', label: 'Efficiency Data' },
  ];

  return (
    <div className="dashboard-tabs-container w-full h-[37px] flex flex-row items-start justify-start opacity-100 overflow-visible font-['Roboto',Arial,sans-serif] bg-[#ededed]">
      <div className="dashboard-tabs-module w-full h-full">
        <div id="tabs" className="w-full h-full">
          <div className="home-tabs-container w-full h-[37px] bg-[#dedede] flex items-end">
            <div className="home-tab w-full h-full overflow-hidden">
              <div className="home-tab-control w-full h-full flex flex-row">
                <ul className="home-tab-container flex flex-row items-end ml-[15px] p-0 list-none h-full">
                  {tabs.map(tab =>
                  {
                    const isActive = activeTab === tab.id;
                    return (
                      <li
                        key={tab.id}
                        className={`home-tab-item cursor-pointer border-2 border-transparent px-[13px] flex items-center mr-[5px] ${
                          isActive
                            ? 'home-active-tab bg-[#ededed] rounded-t-[8px] h-[36px] mt-[3px] pt-[8px] pb-[7px]'
                            : 'h-[34px] mb-0 pt-[6px] pb-[7px]'
                        }`}
                        onClick={() => onTabChange(tab.id)}
                      >
                        <div
                          className={`home-tab-title text-[12px] font-medium leading-[17.1429px] ${
                            isActive ? 'text-[#414042]' : 'text-[rgba(0,0,0,0.54)]'
                          }`}
                        >
                          {tab.label}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
